/**
 * Valida que una contraseña cumpla los requisitos mínimos de seguridad:
 * - Mínimo 8 caracteres
 * - Al menos una mayúscula
 * - Al menos una minúscula
 * - Al menos un dígito numérico
 * - Al menos un caracter especial
 *
 * @param {string} password
 * @returns {{ valid: boolean, message: string | null }}
 */
export function validatePassword(password) {
  if (!password || password.length < 8) {
    return { valid: false, message: "La contraseña debe tener mínimo 8 caracteres" };
  }
  if (!/[A-Z]/.test(password)) {
    return { valid: false, message: "La contraseña debe incluir al menos una mayúscula" };
  }
  if (!/[a-z]/.test(password)) {
    return { valid: false, message: "La contraseña debe incluir al menos una minúscula" };
  }
  if (!/[0-9]/.test(password)) {
    return { valid: false, message: "La contraseña debe incluir al menos un dígito numérico" };
  }
  if (!/[^A-Za-z0-9]/.test(password)) {
    return { valid: false, message: "La contraseña debe incluir al menos un caracter especial" };
  }
  return { valid: true, message: null };
}
